import generateID from '../../generateID';
const axisLabels = ['x', 'y'];
const defaultShift = { x: 0, y: 0 };
export function addZones(signals, datum, options = {}) {
    const zones = [];
    const { shift = defaultShift } = options;
    const { originFrequency = [400, 400] } = datum.info;
    const frequency = { x: originFrequency[0], y: originFrequency[1] };
    for (const signal of signals) {
        const zone = {
            x: {},
            y: {},
            id: generateID(),
            kind: 'signal',
        };
        const signalFormated = {
            id: generateID(),
            kind: 'signal',
            peaks: [],
        };
        const width = { x: 10, y: 10 };
        for (const axis of axisLabels) {
            const { coupling = [], delta, diaIDs = [] } = signal[axis];
            for (const j of coupling) {
                width[axis] += j.coupling;
            }
            if (signal.activeCoupling) {
                const { activeCoupling = [] } = signal;
                for (const j of activeCoupling) {
                    width[axis] += j.coupling;
                }
            }
            width[axis] /= frequency[axis];
            zone[axis] = {
                from: delta - width[axis],
                to: delta + width[axis],
            };
            signalFormated[axis] = {
                delta,
                diaIDs,
                originDelta: delta - shift[axis],
            };
        }
        zones.push({
            ...zone,
            signals: [signalFormated],
        });
    }
    datum.zones.values = zones;
}
//# sourceMappingURL=addZones.js.map